import TextAlign from '@tiptap/extension-text-align';
import TextStyle from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import StarterKit from '@tiptap/starter-kit';
import FontSize from '@tiptap/extension-font-size';
import Link from '@tiptap/extension-link';

const DEFAULT_EXTENSIONS = [
  TextStyle.configure(),
  Underline.configure(),
  TextAlign.configure({
    types: ['heading', 'paragraph'],
  }),
  Link.configure({
    defaultProtocol: 'https',
    protocols: ['mailto', 'tel'],
    openOnClick: false,
    autolink: true,
  }).extend({ inclusive: false }),
  StarterKit.configure({
    bulletList: {
      keepMarks: true,
      keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
    },
    orderedList: {
      keepMarks: true,
      keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
    },
  }),
  FontSize.configure({
    types: ['textStyle'],
  }),
];

export default DEFAULT_EXTENSIONS;
